// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__KrvgO","load4":"loading_load4__V0oz2"};